import { actions as projectActions } from "containers/Projects/Projects.reducer";

export const setActiveProject = (dispatch, iri) =>
    dispatch({
        type: projectActions.STORE_ACTIVE_PROJECT,
        iri,
    });
